import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  AiFillEye,
} from "react-icons/ai";
import {  HiTrash } from "react-icons/hi";
import { ImAttachment } from "react-icons/im";
import { IoMdDownload, IoMdImages } from "react-icons/io";
import {
  getUploadFileCategory,
  uploadFileSession,
} from "../../services/FileUploadService";

import { toastMsg } from "../../Utils/AllConstant";
import {
  getFileExtinsion,
  getFileName,
  isEmpty,
  showToastSuccess,
} from "../../Utils/Helper";
import generatePdfThumbnails from "pdf-thumbnails-generator";
import { addSessionNote } from "../../services/ActivePrograms";
import AttachmentShow from "./AttachmentShow";

export default function AddEditNotesModal(props) {
  let defaultPostDetail;
  let initialPostDetail = {
    title: "",
    description: "",
    image: "",
    video: "",
    document: "",
    //   options: [],
    documentThumbnail: "",
    videoThumbnail: "",
    titlerender: "",
  };
  const [render, setRender] = useState(false);

  const [postType, setPostType] = useState({
    iv: false,
    poll: false,
    doc: false,
  });
  const [postDetail, setPostDetail] = useState(initialPostDetail);
  const [mediaType, setMediaType] = useState("image");
  const [imageError, setImageError] = useState(false);
  const [isLoader, setLoaderSave] = useState(false);
  const [contentError, setContentError] = useState(false);
  const [docError, setDocError] = useState(false);
  const [optionError, setOptionError] = useState(false);
  const [dayError, setDayError] = useState(false);
  const [documentExt, setDocumentExt] = useState();
  const [isAttachmentCanceled, setIsAttachmentIsCanceled] = useState(false);
  const [reload, setReload] = useState(false);

  useEffect(() => {
    defaultPostDetail = {
      title: props?.data?.noteTitle || "",
      description: props?.data?.noteDescription || "",
      image: props?.data?.file?.image || "",
      video: props?.data?.file?.video || "",
      document: props?.data?.file?.document || "",
      // documentThumbnail: props?.data?.file?.documentThumbnail || "",
      // videoThumbnail: props?.data?.file?.videoThumbnail || "",
      shareNoteId: props?.data?.shareNoteId || "",
      titlerender: props?.data?.noteTitle || "",
    };
    setIsAttachmentIsCanceled(
      props.operation === "add"
        ? true
        : props.data.file.document ||
          props.data.file.image ||
          props.data.file.video
        ? false
        : true
    );
    setMediaType(props?.data?.file?.video && "video");
    setPostDetail(defaultPostDetail);
    setDocumentExt(props?.data?.file?.document);
  }, [props.data, postDetail.titlerender]);

  useEffect(() => {
    setPostDetail({
      ...postDetail,
      image: "",
      video: "",
      document: "",
      // videoThumbnail: "",
      // documentThumbnail: "",
    });
    setIsAttachmentIsCanceled(true);
  }, [reload]);


  const urltoFile = (url, filename, mimeType) => {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  };

  // const createThumb = async (event) => {
  //   try {
  //     const thumbnails = await generatePdfThumbnails(
  //       URL.createObjectURL(event.target.files[0]),
  //       250
  //     );
  //     //Usage example:
  //     urltoFile(thumbnails[0].thumbnail, "thumb.png", "image/png").then(
  //       function (file) {
  //         // console.log(file);
  //         setPostDetail((prev) => {
  //           return { ...prev, documentThumbnail: [file] };
  //         });
  //       }
  //     );
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  const generateVideoThumbnail = (file) => {
    return new Promise((resolve) => {
      const canvas = document.createElement("canvas");
      const video = document.createElement("video");

      // this is important
      video.autoplay = true;
      video.muted = true;
      video.src = URL.createObjectURL(file);

      video.onloadeddata = () => {
        let ctx = canvas.getContext("2d");

        canvas.width = video.videoWidth / 5;
        canvas.height = video.videoHeight / 5;

        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        video.pause();
        return resolve(canvas.toDataURL("image/png"));
      };
    });
  };

  // function captureVideoThumb(e) {
  //   generateVideoThumbnail(e.target.files[0]).then((dt) => {
  //     // console.log(dt)
  //     urltoFile(dt, "videoThumb.png", "image/png").then(function (file) {
  //       // console.log(file);
  //       setPostDetail((prev) => {
  //         return { ...prev, videoThumbnail: [file] };
  //       });
  //     });
  //   });
  // }

  const handleSubmit = () => {
    // e.preventDefault();
    let isValid = true;
    // if (postType.iv && !postDetail.image[0] && !postDetail.video[0]) {
    //     isValid = false;
    //     setImageError(true)
    // }

    if (
      !postDetail.title ||
      isEmpty(postDetail.title) ||
      postDetail.title === "<p><br></p>"
    ) {
      isValid = false;
      setContentError(true);
    }

    if (
      !postDetail.description ||
      isEmpty(postDetail.description) ||
      postDetail.description === "<p><br></p>"
    ) {
      isValid = false;
      setContentError(true);
    }

    if (
      postType.doc &&
      (!postDetail.document || isEmpty(postDetail.document))
    ) {
      isValid = false;
      setDocError(true);
    }


    if (isValid && !isLoader) {
      setLoaderSave(true);
      // console.log(getFileType(postDetail.image[0]));
      createPost();
    }

  };
  const createPost = async () => {
    props.onHide();
    try {
      // setLoaderSave(true);
      console.log('inside Createpost start')
      const documentName =
      isAttachmentCanceled && postDetail?.document[0]
      ? getFileName(postDetail?.document[0]) +
        "." +
        getFileExtinsion(postDetail?.document[0])
      : '';
  const imageName =
    isAttachmentCanceled && postDetail.image[0]
      ? getFileName(postDetail.image[0]) +
        "." +
        getFileExtinsion(postDetail.image[0])
      : '';
  const videoName =
    isAttachmentCanceled && postDetail.video[0]
      ? getFileName(postDetail.video[0]) +
        "." +
        getFileExtinsion(postDetail.video[0])
      : '';
      // const docthumbnail = isAttachmentCanceled && `docThumbnail__${uuidv4()}`;
      // const vthumbnail = isAttachmentCanceled && `videoThumbnail__${uuidv4()}`;
      // console.log(imageName, videoName);

      if (postType.iv && postDetail.video[0])
        await uploadFileSession(
          postDetail.video[0],
          getUploadFileCategory.sessionVideo,
          videoName,
          props.pid
        );
      // if (postType.iv && postDetail.video[0])
      //   await uploadFileSession(
      //     postDetail.videoThumbnail[0],
      //     getUploadFileCategory.sessionVideo,
      //     vthumbnail,
      //     props.pid
      //   );
      if (postType.iv && postDetail.image[0])
        await uploadFileSession(
          postDetail.image[0],
          getUploadFileCategory.sessionImage,
          imageName,
          props.pid
        );
      // postDetail.document[0] && await uploadFileSession(
      //     postDetail.document[0],
      //     getUploadFileCategory.postDocument,
      //     documentName
      // );
      // if (postType.doc && postDetail.documentThumbnail[0])
      //   await uploadFileSession(
      //     postDetail.documentThumbnail[0],
      //     getUploadFileCategory.sessionDocument,
      //     docthumbnail,
      //     props.pid
      //   );

      if (postType.doc && postDetail.document[0])
        await uploadFileSession(
          postDetail.document[0],
          getUploadFileCategory.sessionDocument,
          documentName,
          props.pid
        );

      let parms = {};
      if (props.operation === "add") {
        parms["programId"] = props.pid;
        parms["sessionId"] = props.sid;
        parms["title"] = postDetail.title;
        parms["description"] = postDetail.description;
        parms["file"] = {
          video: postType.iv && videoName !== "" ? videoName : "",
          // videoThumbnail: postType.iv && videoName ? vthumbnail : "",
          image: postType.iv && imageName !== "" ? imageName : "",
          document: postType.doc && documentName !== "" ? documentName : "",
          // documentThumbnail: postType.doc ? docthumbnail : "",
        };
        parms["userId"] = localStorage.getItem("user_id").toString();
      }
      if (props.operation !== "add") {
        parms["programId"] = props.pid;
        parms["sessionId"] = props.sid;
        parms["title"] = postDetail.title;
        parms["description"] = postDetail.description;
        parms["file"] = {
          video:
            isAttachmentCanceled && postType.iv && videoName  !== "" 
              ? videoName
              : postDetail?.video,
          // videoThumbnail:

          //   (isAttachmentCanceled && postType.iv && videoName)
          //     ? vthumbnail
          //     : postDetail?.videoThumbnail,
          image:
            isAttachmentCanceled && postType.iv && imageName  !== "" 
              ? imageName
              : postDetail?.image,
          document:
            isAttachmentCanceled && postType.doc && documentName  !== "" 
              ? documentName
              : postDetail?.document,
          // documentThumbnail:

          //   (isAttachmentCanceled && postType.doc)
          //     ? docthumbnail
          //     : postDetail?.documentThumbnail,
        };
        parms["userId"] = localStorage.getItem("user_id").toString();
        parms["shareNoteId"] = postDetail.shareNoteId;
      }
      const response = await addSessionNote(parms);
      if (response) {
        props.operation !== "add"
          ? showToastSuccess(toastMsg.updateNote)
          : showToastSuccess(toastMsg.createNote);
        setPostDetail(initialPostDetail);
        props.getProgram();
        // props.getGroupPosts();
        // navigate(-1)
      }
      setLoaderSave(false);
    } catch (error) {
      setLoaderSave(false);
      console.log(error);
    }
  };

  const getFileType = (file) => {
    if (file.type.match("image.*")) return "image";

    if (file.type.match("video.*")) return "video";

    if (file.type.match("audio.*")) return "audio";

    return "other";
  };

  const onChangeDetail = (key, value) => {
    setPostDetail({ ...postDetail, [key]: value });
  };

  // const instandDn = (dt) => {
  //   console.log(dt);
  //   const a = document.createElement("a");
  //   document.body.appendChild(a);
  //   var url = URL.createObjectURL(dt);
  //   console.log(url);
  //   a.href = url;
  //   a.download = dt.name;
  //   a.target = "_blank";
  //   a.click();
  //   setTimeout(() => {
  //     window.URL.revokeObjectURL(url);
  //     document.body.removeChild(a);
  //   }, 0);
  // };

  // const handleView = (file) =>{
  //   if(file === postDetail.image){
  //     console.log(`image/${file.split('.')[1]}`)
  //     return window.URL.createObjectURL(new Blob([file] , {type: `image/${file.split('.')[1]}`}))
  //   }if(file === postDetail.video){
  //     console.log(`video/${file.split('.')[1]}`)
  //     return window.URL.createObjectURL(new Blob([file] , {type: `video/${file.split('.')[1]}`}))
  //   }
  // }
  // const handleDownload = (url, name) => {
  //   fetch(url)
  //     .then((response) => response.blob())
  //     .then((blob) => {
  //       const url = window.URL.createObjectURL(new Blob([blob]));
  //       const a = document.createElement("a");
  //       a.style.display = "none";
  //       a.href = url;
  //       a.download = name; // Change the filename as needed
  //       document.body.appendChild(a);
  //       a.click();
  //       window.URL.revokeObjectURL(url);
  //     })
  //     .catch((error) => {
  //       console.error("Error downloading attachment:", error);
  //     });
  // };

  return (
    <Modal
      {...props}
      onExited={() => {
        setPostDetail(initialPostDetail);
        // setFormValues([{ option: "" }, { option: "" }]);
        // setAttachmentList([]);
        setContentError(false);
        setDocError(false);
        setImageError(false);
        setOptionError(false);
        setDayError(false);
      }}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {props.operation === "add" ? (
        <Modal.Body>
          {/* <h4 className=" headFont ">Centered Modal</h4> */}
          {/* <div className="d-flex gap-3 my-2">
            <SquareAvatar
              src={profilePicture}
              className="member_listimage rounded-circle"
            />
            <div>
                <p className='mb-0 fw-bold'>{fname} {sname}</p>
                <span class="badge bg-less-white text-dark"><HiUserGroup size="1.2em" className="me-1 mb-1" /> {props.gname}</span>
            </div>
        </div> */}
          {/* <form action=""> */}
          <div className="row align-items-center">
            <div className="col-3 fs-5 ">Title of Note:</div>
            <div className="col-8">
              <input
                className="form-control description_inputf px-2 m-0"
                maxLength={60}
                style={{ outline: "none" }}
                onChange={(e) => {
                  onChangeDetail("title", e.target.value);
                  setContentError(false);
                }}
                placeholder="Write something..."
                value={postDetail?.title}
              />
            </div>
          </div>
          {contentError ? (
            <h6 className="text-danger error mt-2">
              Please write something...
            </h6>
          ) : null}
          <div className="d-flex justify-content-start align-items-center ">
            <textarea
              className="form-control fs-5 px-0  border-0 "
              rows={10}
              style={{ outline: "none", height: "auto" }}
              onChange={(e) => {
                onChangeDetail("description", e.target.value);
                setContentError(false);
              }}
              placeholder="Write something..."
              value={postDetail?.description}
            />
          </div>
          {contentError ? (
            <h6 className="text-danger error mt-2">
              Please write something...
            </h6>
          ) : null}
          {/* Image/Video Upload */}
          {postType.iv && (
            <div className="pb-4 position-relative">
              <p className="whole_label resFontx mt-4">Upload image/video</p>

              <div className="position-relative">
                {!postDetail?.image[0] && !postDetail?.video[0] ? (
                  <div
                    className="rounded d-flex ps-2 align-items-center fw-semibold "
                    style={{
                      height: "50px",
                      color: "black",
                      width: "100%",
                      // border: "1px solid rgba(21, 101, 99, 1)",
                      backgroundColor: "rgba(247, 247, 247, 1)",
                    }}
                  >
                    Attach Image/video
                  </div>
                ) : (
                  <div
                    className="rounded d-flex ps-2 align-items-center fw-semibold "
                    style={{
                      height: "50px",
                      color: "black",
                      width: "100%",
                      // border: "1px solid rgba(21, 101, 99, 1)",
                      backgroundColor: "rgba(247, 247, 247, 1)",
                    }}
                  >
                    <div
                      style={{
                        width: "70%",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      }}
                      className=""
                    >
                      {mediaType === "image"
                        ?  postDetail?.image[0]?.name
                        : postDetail?.video[0]?.name}
                    </div>
                  </div>
                )}

                {!postDetail?.image.length > 0 && !postDetail?.video.length > 0 ? (
                  <>
                    <input
                      type="file"
                      className="form-control uploader-input"
                      accept="image/*, video/*"
                      style={{ marginRight: "7px" }}
                      onChange={(e) => {
                        setPostDetail({ ...postDetail, image: [], video: [] });

                        if (getFileType(e.target.files[0]) != "image") {
                          setMediaType("video");
                          // onChangeDetail("video", [e.target.files[0]]);
                          // captureVideoThumb(e);
                          setPostDetail({
                            ...postDetail,
                            image: '',
                            video: [e.target.files[0]],
                          });
                        } else {
                          setMediaType("image");
                          // onChangeDetail("image", [e.target.files[0]]);
                          setPostDetail({
                            ...postDetail,
                            image: [e.target.files[0]],
                            video: '',
                          });
                        }

                        // onChangeDetail(mediaType, postDetail[mediaType]);

                        setImageError(false);
                      }}
                    />
                  </>
                ) : (
                  <div
                    className="pointer d-flex justify-content-center align-items-center gap-2 pe-2"
                    style={{
                      position: "absolute",
                      top: "0",
                      right: "0",
                      height: "50px",
                    }}
                  >
                    <a
                      className="text-decoration-none text-black d-flex align-items-center"
                      href={
                        mediaType === "image"
                          ? postDetail.image[0] &&
                            URL.createObjectURL(postDetail.image[0])
                          : postDetail.video[0] &&
                            URL.createObjectURL(postDetail.video[0])
                      }
                      rel="noreferrer"
                      target="_top"
                      download={
                        mediaType === "image"
                          ? postDetail.image[0]?.name
                          : postDetail.video[0]?.name
                      }
                    >
                      <IoMdDownload />
                    </a>
                    <a
                      className="text-decoration-none text-black d-flex align-items-center"
                      href={
                        mediaType === "image"
                          ? postDetail.image[0] &&
                            URL.createObjectURL(postDetail.image[0])
                          : postDetail.video[0] &&
                            URL.createObjectURL(postDetail.video[0])
                      }
                      target="_blank"
                    >
                      <AiFillEye />
                    </a>
                    <HiTrash
                      onClick={() =>
                        setPostDetail({
                          ...postDetail,
                          image: "",
                          video: "",
                          document: "",
                        })
                      }
                    />
                  </div>
                )}
              </div>

              {imageError ? (
                <h6 className="text-danger error mt-2">
                  Please select a image/video
                </h6>
              ) : null}
            </div>
          )}
          {/* Document Upload */}
          {postType.doc && (
            <div className="my-4">
              <p className="whole_label resFontx">
                Upload documents <span className="text-danger"> *</span>
              </p>
              <div
                className=" d-flex rounded"
                style={{
                  height: "50px",
                  color: "black",
                  width: "100%",
                  // border: "1px solid rgba(21, 101, 99, 1)",
                  backgroundColor: "rgba(247, 247, 247, 1)",
                }}
              >
                {/* File Uploader */}
                {!postDetail?.document[0] && (
                  <div className=" me-3  position-relative w-100 rounded">
                    <p
                      className="position-absolute fw-semibold "
                      style={{ top: "10px", left: "5px" }}
                    >
                      Attach Document
                    </p>
                    <input
                      type="file"
                      className="form-control uploader-input"
                      accept="application/pdf"
                      multiple
                      // onClick={(e) => (e.target.value = null)}
                      onChange={(e) => {
                        // console.log(e.target.files[0]);
                        // setAttachmentList([
                        //   e.target.files.[0]
                        // ]);
                        setPostDetail({
                          ...postDetail,
                          document: [e.target.files[0]],
                        });
                        setDocError(false);
                        // createThumb(e);
                      }}
                    />
                  </div>
                )}
                {/* All Attached Files */}
                {postDetail?.document[0] && (
                  <div
                    className="me-3 d-flex justify-content-between align-items-center"
                    style={{
                      position: "relative",
                      width: "100%",
                      left: "5px",
                      cursor: "pointer",
                    }}
                  >
                    <p
                      style={{
                        width: "70%",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      }}
                      className="mb-0 fw-semibold "
                    >
                      {postDetail?.document[0].name}
                    </p>
                    <div
                      className="pointer d-flex justify-content-center align-items-center gap-2 pe-2"
                      style={{
                        position: "absolute",
                        top: "0",
                        right: "0",
                        height: "50px",
                      }}
                    >
                      <a
                        className="text-decoration-none text-black d-flex align-items-center"
                        href={
                          postDetail?.document[0] &&
                          URL.createObjectURL(postDetail?.document[0])
                        }
                        rel="noreferrer"
                        target="_top"
                        download={postDetail?.document[0]?.name}
                      >
                        <IoMdDownload />
                      </a>
                      <a
                        className="text-decoration-none text-black d-flex align-items-center"
                        href={
                          postDetail?.document[0] &&
                          URL.createObjectURL(postDetail?.document[0])
                        }
                        target="_blank"
                      >
                        <AiFillEye />
                      </a>
                      <HiTrash
                        onClick={() =>
                          setPostDetail({
                            ...postDetail,
                            image: "",
                            video: "",
                            document: "",
                          })
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
              {docError ? (
                <h6 className="text-danger error mt-2">
                  Please add a document
                </h6>
              ) : null}
            </div>
          )}
          {/* </form> */}

          <div className="border rounded p-3 d-flex justify-content-between">
            <p className="mb-0"></p>
            <div className="post-actions">
              <IoMdImages
                onClick={() =>
                  setPostType((prev) => {
                    return { prev, iv: true };
                  })
                }
                size="1.5em"
                className="ms-2 text-success"
              />
              {/* <CgPoll onClick={() => setPostType(prev => { return { prev, poll: true } })} size="1.4em" className='ms-2 text-danger' /> */}
              <ImAttachment
                onClick={() =>
                  setPostType((prev) => {
                    return { prev, doc: true };
                  })
                }
                size="1.2em"
                className="ms-2 text-primary"
              />
            </div>
          </div>
        </Modal.Body>
      ) : (
        <Modal.Body>
          {/* <h4 className=" headFont ">Centered Modal</h4> */}
          {/* <div className="d-flex gap-3 my-2">
          <SquareAvatar
            src={profilePicture}
            className="member_listimage rounded-circle"
          />
          <div>
              <p className='mb-0 fw-bold'>{fname} {sname}</p>
              <span class="badge bg-less-white text-dark"><HiUserGroup size="1.2em" className="me-1 mb-1" /> {props.gname}</span>
          </div>
      </div> */}
          {/* <form action=""> */}
          <div className="row align-items-center">
            <div className="col-3 fs-5 ">Title of Note:</div>
            <div className="col-8">
              <input
                className="form-control description_inputf px-2 m-0"
                maxLength={60}
                style={{ outline: "none" }}
                onChange={(e) => {
                  onChangeDetail("title", e.target.value);
                  setContentError(false);
                }}
                placeholder="Write something..."
                value={postDetail?.title}
              />
            </div>
          </div>
          {contentError ? (
            <h6 className="text-danger error mt-2">
              Please write something...
            </h6>
          ) : null}
          <div className="d-flex justify-content-start align-items-center ">
            <textarea
              className="form-control fs-5 px-0  border-0 "
              rows={10}
              style={{ outline: "none", height: "auto" }}
              onChange={(e) => {
                onChangeDetail("description", e.target.value);
                setContentError(false);
              }}
              placeholder="Write something..."
              value={postDetail?.description}
            />
          </div>
          {contentError ? (
            <h6 className="text-danger error mt-2">
              Please write something...
            </h6>
          ) : null}
          {/* Image/Video Upload */}
          {/* <div className="my-2" style={{ height: "auto", width: "100%" }}>
            {props?.data?.file?.image[0] &&
              (!postDetail?.image[0] ? (
                <img
                  src={
                    props?.data?.file?.image[0] &&
                    ApiConfig.ImageUrl +
                      `sessions/documents/${props.pid}/` +
                      props?.data?.file?.image[0]
                  }
                  alt=""
                  style={{ height: "170px" }}
                  className="active_dummyimg"
                />
              ) : null)}
            {props?.data?.file?.video[0] &&
              (!postDetail?.video[0] ? (
                <video className="active_dummyimg" style={{height:'170px'}}>
                  <source
                    src={
                      props?.data?.file?.video[0] &&
                      ApiConfig.ImageUrl +
                        `sessions/documents/${props.pid}/` +
                        props?.data?.file?.video[0]
                    }
                    type="video/mp4"
                    
                  />
                  Your browser does not support the video tag.
                </video>
              ) : null)}
          </div> */}
          {(props.data.file.document ||
            props.data.file.image ||
            props.data.file.video) &&
          !isAttachmentCanceled ? (
            <AttachmentShow
              setReload={setReload}
              props={props}
              setIsAttachmentIsCanceled={setIsAttachmentIsCanceled}
              setPostDetail={setPostDetail}
              pid={props.pid}
              sid={props.sid}
            />
          ) : null}
          {postType.iv && isAttachmentCanceled && (
            <div className="pb-4 position-relative">
              <p className="whole_label resFontx mt-4">Upload image/video</p>

              <div className="position-relative">
                {!postDetail?.image[0] && !postDetail?.video[0] ? (
                  <div
                    className="rounded d-flex ps-2 align-items-center fw-semibold "
                    style={{
                      height: "50px",
                      color: "black",
                      width: "100%",
                      // border: "1px solid rgba(21, 101, 99, 1)",
                      backgroundColor: "rgba(247, 247, 247, 1)",
                    }}
                  >
                    Attach Image/video
                  </div>
                ) : (
                  <div
                    className="rounded d-flex ps-2 align-items-center fw-semibold "
                    style={{
                      height: "50px",
                      color: "black",
                      width: "100%",
                      // border: "1px solid rgba(21, 101, 99, 1)",
                      backgroundColor: "rgba(247, 247, 247, 1)",
                    }}
                  >
                    <div
                      style={{
                        width: "70%",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      }}
                      className=""
                    >
                      {mediaType === "image" && postDetail?.image[0]?.name}
                      {mediaType === "video" && postDetail?.video[0]?.name}
                    </div>
                  </div>
                )}
                {!postDetail?.image?.length > 0 && !postDetail?.video?.length > 0 ? (
                  <>
                    <input
                      type="file"
                      className="form-control uploader-input"
                      accept="image/*, video/*"
                      style={{ marginRight: "7px" }}
                      onChange={(e) => {
                        setPostDetail({
                          ...postDetail,
                          image: "",
                          video: "",
                          document: "",
                        });

                        if (getFileType(e.target.files[0]) != "image") {
                          setMediaType("video");
                          // onChangeDetail("video", [e.target.files[0]]);
                          // captureVideoThumb(e);
                          setPostDetail({
                            ...postDetail,
                            image: "",
                            video: [e.target.files[0]],
                            document: "",
                          });
                        } else {
                          // console.log(postDetail.image[0]);
                          setMediaType("image");
                          // onChangeDetail("image", [e.target.files[0]]);
                          setPostDetail({
                            ...postDetail,
                            image: [e.target.files[0]],
                            video: "",
                            document: "",
                          });
                        }

                        // onChangeDetail(mediaType, postDetail[mediaType]);

                        setImageError(false);
                      }}
                    />
                  </>
                ) : (
                  <div
                    className="pointer d-flex justify-content-center align-items-center gap-2 pe-2"
                    style={{
                      position: "absolute",
                      top: "0",
                      right: "0",
                      height: "50px",
                    }}
                  >
                    <a
                     href={
                      mediaType === "image"
                        ? postDetail.image[0] &&
                          URL.createObjectURL(postDetail.image[0])
                        : postDetail.video[0] &&
                          URL.createObjectURL(postDetail.video[0])
                    }
                      className="text-decoration-none text-black d-flex align-items-center"
                      rel="noreferrer"
                      target="_top"
                      download={
                        mediaType === "image"
                          ? postDetail.image[0]?.name
                          : postDetail.video[0]?.name
                      }
                    >
                      <IoMdDownload />
                    </a>
                    <a
                     href={
                      mediaType === "image"
                        ? postDetail.image[0] &&
                          URL.createObjectURL(postDetail.image[0])
                        : postDetail.video[0] &&
                          URL.createObjectURL(postDetail.video[0])
                    }
                      target="_blank"
                      className="text-decoration-none text-black d-flex align-items-center"
                    >
                      <AiFillEye />
                    </a>
                    <HiTrash
                      onClick={() =>
                        setPostDetail({
                          ...postDetail,
                          image: "",
                          video: "",
                          document: "",
                        })
                      }
                    />
                  </div>
                )}
              </div>

              {imageError ? (
                <h6 className="text-danger error mt-2">
                  Please select a image/video
                </h6>
              ) : null}
            </div>
          )}
          {/* Document Upload */}
          {postType.doc && isAttachmentCanceled && (
            <div className="my-4">
              <p className="whole_label resFontx">Upload documents</p>

              <div
                className=" d-flex rounded "
                style={{
                  height: "50px",
                  color: "black",
                  width: "100%",
                  // border: "1px solid rgba(21, 101, 99, 1)",
                  backgroundColor: "rgba(247, 247, 247, 1)",
                }}
              >
                {/* File Uploader */}
                {!postDetail?.document?.length > 0 ? (
                  <div className=" me-3  position-relative w-100 rounded">
                    <p
                      className="position-absolute fw-semibold "
                      style={{ top: "12px", left: "5px" }}
                    >
                      Attach Document
                    </p>
                    <input
                      type="file"
                      className="form-control uploader-input"
                      accept="application/pdf"
                      // onClick={(e) => (e.target.value = null)}
                      onChange={(e) => {
                        // console.log(e.target.files[0]);
                        // setAttachmentList([
                        //   e.target.files.[0]
                        // ]);
                        setPostDetail({
                          ...postDetail,
                          document: [e.target.files[0]],
                        });
                        setDocError(false);
                        // createThumb(e);
                      }}
                    />
                  </div>
                ) : (
                  postDetail?.document[0] && (
                    <div
                      className="me-3 d-flex justify-content-between align-items-center"
                      style={{
                        position: "relative",
                        width: "100%",
                        left: "5px",
                        cursor: "pointer",
                      }}
                    >
                      <p
                        style={{
                          width: "70%",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                        }}
                        className="mb-0"
                      >
                         {postDetail?.document[0]?.name}
                      </p>
                      <div
                        className="pointer d-flex justify-content-center align-items-center gap-2 pe-2"
                        style={{
                          position: "absolute",
                          top: "0",
                          right: "0",
                          height: "50px",
                        }}
                      >
                        <a
                          href={
                            postDetail?.document[0] &&
                            URL.createObjectURL(postDetail?.document[0])
                          }
                          rel="noreferrer"
                          target="_top"
                          download={postDetail?.document[0].name}
                          className="text-decoration-none text-black d-flex align-items-center"
                        >
                          <IoMdDownload />
                        </a>
                        <a
                         href={
                          postDetail?.document[0] &&
                          URL.createObjectURL(postDetail?.document[0])
                        }
                          className="text-decoration-none text-black d-flex align-items-center"
                          target="_blank"
                        >
                          <AiFillEye />
                        </a>
                        <HiTrash
                          onClick={() =>
                            setPostDetail({
                              ...postDetail,
                              image: "",
                              video: "",
                              document: "",
                            })
                          }
                        />
                      </div>
                    </div>
                  )
                )}
                {/* All Attached Files */}
              </div>
              {docError ? (
                <h6 className="text-danger error mt-2">
                  Please add a document
                </h6>
              ) : null}
            </div>
          )}
          {/* </form> */}

          <div className="border rounded p-3 d-flex justify-content-between">
            <p className="mb-0"></p>
            <div className="post-actions">
              <IoMdImages
                onClick={() =>
                  setPostType((prev) => {
                    return { prev, iv: true };
                  })
                }
                size="1.5em"
                className="ms-2 text-success"
              />
              {/* <CgPoll onClick={() => setPostType(prev => { return { prev, poll: true } })} size="1.4em" className='ms-2 text-danger' /> */}
              <ImAttachment
                onClick={() =>
                  setPostType((prev) => {
                    return { prev, doc: true };
                  })
                }
                size="1.2em"
                className="ms-2 text-primary"
              />
            </div>
          </div>
        </Modal.Body>
      )}
      <Modal.Footer className="mx-3 px-0 justify-content-between">
        <button
          className="description_btnsave-white mx-0"
          onClick={() => {
            setPostDetail(initialPostDetail);
            setPostType({ iv: false, poll: false, doc: false });
            setIsAttachmentIsCanceled(false);
            setRender(!render);
            props.onHide();
          }}
        >
          Cancel
        </button>
        <button
          className="description_btnsave mx-0"
          onClick={() => {
            // props.onHide();
            handleSubmit();
            setPostType({ iv: false, poll: false, doc: false });
            setIsAttachmentIsCanceled(false);
          }}
        >
          Save Session Note
        </button>
      </Modal.Footer>
    </Modal>
  );
}
